export default "__VITE_ASSET__CXd8zNcn__"